import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { ShopEditAccountTemplate } from 'components/Templates'
import { useDispatch, useSelector } from 'react-redux'
import { getShopRef } from 'reducks/store/selectors'
import { State } from 'index'
import { fetchShop } from 'reducks/shop/operations'

const Note: FC = () => {
  const dispatch = useDispatch()
  const shopRef = useSelector((state: State) => getShopRef(state))

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShop(shopRef.id))
  }, [shopRef])

  return (
    <Layout title={'特定商取引法に関する記載'}>
      <ShopEditAccountTemplate isCreatePage={false} isEditedByOwner={true} shopId={shopRef ? shopRef.id : ''} />
    </Layout>
  )
}

export default Note
